import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import {
  handleSendInvitationToEmail,
  addFollowerToQuote,
  changeOwnerOfQuote,
  fetchUsersFromSameCompany,
  deleteFollowerFromQuotation,
  searchUserByEmail,
} from "../../utils/actions/commanActions";
import { toast } from "react-toastify";
import CaptchaModal from "../CaptchaModal/CaptchaModal";
import { DeleteIcon } from "../Icons";
import { Modal as AntModal } from "antd";
import { validateEmail } from "../../utils/helper";
import { Fragment } from "react";
import { useRef } from "react";

const TeamCollaboration = ({
  teamMemberModalShow,
  setTeamMemberModalShow,
  selectedQuoteForTeam,
  fetchDataForUser,
  updateQuoteData,
  isGenericUser,
  isAdmin,
  userEmail,
  setTeamLoading,
}) => {
  const token = localStorage.getItem("Token");
  const loggedInUserEmail = localStorage.getItem("email");

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isEmailExists, setIsEmailExists] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [userSelectedToDelete, setUserSelectedToDelete] = useState("");
  const [showCaptchaModal, setShowCaptchaModal] = useState(false);
  const [isCheckingEmail, setIsCheckingEmail] = useState(false);
  const [emailList, setEmailList] = useState([]);
  const ref = useRef(false);



  useEffect(() => {
    if (!email || ref.current) {
      setIsEmailExists(true);
      setEmailList([]);
      return;
    }

    const handler = setTimeout(async () => {
      try {
        const response = await searchUserByEmail(
          token,
          email,
          selectedQuoteForTeam?.userId?.companySiteId?.domain
        );
        if (response?.payload && response?.payload.length > 0) {
          setIsEmailExists(true);
          if (Array.isArray(response.payload)) {
            const data = selectedQuoteForTeam.followers;
            const filteredUsers = response.payload.filter(user => {
              return !data.some(follower => follower.email === user.email);
            });
            setEmailList(filteredUsers);
          }

        }
        else {
          setIsEmailExists(false);
          setEmailList([]);
        }
      } catch (error) {
        console.error("Error during searchUserByEmail:", error);
      }
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [email, token, selectedQuoteForTeam]);


  const handleTeamMemberModalClose = () => {
    setTeamMemberModalShow(false);
    setEmail("");
    setFirstName("");
    setLastName("");
    setErrorMessage("");
  };

  const handleSendInvitation = async (isEmailSend) => {
    try {
      setErrorMessage("");

      if (!email || !validateEmail(email)) {
        setErrorMessage("Please enter a valid email address.");
        return;
      }
      //check if email is already exists in the list
      const isEmailExistsInList = selectedQuoteForTeam.followers.some(
        (item) => item.email === email
      );
      if (isEmailExistsInList) {
        setErrorMessage("This email is already added to the team.");
        return;
      }

      if (!isEmailExists && !firstName) {
        setErrorMessage("First name is required.");
        return;
      }

      const isGenericCompany = selectedQuoteForTeam?.userId?.companySiteId?.domain === "*";
      const domain = email.split("@")[1];
      const currentUserDomain = (isAdmin ? userEmail : loggedInUserEmail).split("@")[1];

      if (!isGenericCompany && domain !== currentUserDomain) {
        setErrorMessage("Only email addresses associated with your company domain are allowed.");
        return;
      }
      setTeamMemberModalShow(false);

      const content =
        !isEmailSend
          ? `Are you sure you want to add this quotation to the team for ${email}?`
          : `Are you sure you want to send an invitation for this quotation to ${email}?`;

      const confirmed = await new Promise((resolve) =>
        AntModal.confirm({
          title: "Confirm",
          content,
          okText: "Yes",
          cancelText: "No",
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        })
      );


      if (!confirmed) return;

      setTeamLoading?.(true);
      setTeamMemberModalShow(false);

      const response = await handleSendInvitationToEmail(token, {
        newUserEmail: email,
        newUserFirstName: firstName,
        newUserLastName: lastName,
        quoteId: selectedQuoteForTeam._id,
        userEmail: isAdmin ? userEmail : loggedInUserEmail,
        isEmailSend,
      });

      if (response.status) {
        toast.success(isEmailSend ? response.message : 'Email added to team ');
        updateQuoteData(response.data);
      } else {
        setErrorMessage(response.message);
      }

      setEmail("");
      setFirstName("");
      setLastName("");
    } catch (error) {
      console.error(error);
    } finally {
      setTeamLoading?.(false);
    }
  };

  const handleChangeOwnerDropDown = async (e) => {
    if (e.target.value === "follower") return;
    setTeamMemberModalShow(false);

    const confirmed = await new Promise((resolve) =>
      AntModal.confirm({
        title: "Change Project Owner",
        content: "Are you sure you want to change the owner of this project?",
        okText: "Yes",
        cancelText: "No",
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
        zIndex: 100000,
      })
    );

    if (!confirmed) return;

    const data = {
      quoteRefId: selectedQuoteForTeam.RefId,
      userId: e.target.value,
      quoteId: selectedQuoteForTeam._id,
    };

    const response = await changeOwnerOfQuote(token, data);
    if (response.status) {
      updateQuoteData(response.data);
      fetchDataForUser();
      toast.success("Owner changed successfully");
      setTeamMemberModalShow(false);
    }
  };

  const handleDeleteUserFromTeam = async () => {
    if (selectedQuoteForTeam.userId._id === userSelectedToDelete) {
      setErrorMessage("Cannot delete owner of the project.");
      return;
    }

    const response = await deleteFollowerFromQuotation(token, {
      RefId: selectedQuoteForTeam.RefId,
      userSelectedToDelete,
    });

    if (response.status) {
      const updatedFollowers = selectedQuoteForTeam.followers.filter(
        (item) => item._id !== userSelectedToDelete
      );
      updateQuoteData({ ...selectedQuoteForTeam, followers: updatedFollowers });
      toast.success(response.message);
      setTeamMemberModalShow(false);
    } else {
      setErrorMessage("An error occurred. Please try again later.");
    }
  };

  return (
    <div>
      <CaptchaModal
        showModal={showCaptchaModal}
        handleClose={() => {
          setShowCaptchaModal(false);
          setUserSelectedToDelete("");
        }}
        handleSendEmail={handleDeleteUserFromTeam}
        buttonText={"Delete"}
      />

      {teamMemberModalShow && (
        <Modal
          size="lg"
          dialogClassName="w-4/5 lg:w-3/5 mx-auto"
          centered
          show={teamMemberModalShow}
          onHide={handleTeamMemberModalClose}
        >
          <Modal.Header closeButton>
            <Modal.Title className="sub-header">Team Members</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="share-quote-div">
              <div className="relative w-full">
                <Form.Control
                  className="follower-input"
                  value={email}
                  placeholder="Enter email to send invitation"
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setErrorMessage("");
                    ref.current = false;
                  }}
                />

                {/* Autocomplete list */}
                {emailList.length > 0 && (
                  <ul className="absolute z-50 left-0 right-0 border rounded mt-1 bg-white shadow max-h-40 overflow-y-auto">
                    {emailList.map((user) => (
                      <li
                        key={user.email}
                        className="px-3 py-2 cursor-pointer hover:bg-gray-100"
                        onClick={() => {
                          setEmail(user.email);
                          setEmailList([]);
                          ref.current = true;
                        }}
                      >
                        {user.email}{" "}
                        <span className="text-xs text-gray-500">
                          ({user.firstName} {user.lastName})
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>



              {/* Name input for new users */}
              {!isEmailExists && email ? (
                <div className="space-y-4 py-4">
                  <div>
                    <label className="text">First Name</label>
                    <Form.Control
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      type="text"
                      placeholder="Enter first name"
                    />
                  </div>
                  <div>
                    <label className="text">Last Name</label>
                    <Form.Control
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      type="text"
                      placeholder="Enter last name"
                    />
                  </div>
                </div>
              ) : null}

              {isCheckingEmail ? (
                <button className="primary-btn mt-2" disabled>
                  Checking...
                </button>
              ) : (
                <div className="flex items-center gap-x-3">
                  <button onClick={() => handleSendInvitation(false)} className="primary-btn mt-2">
                    Add to team
                  </button>
                  <button onClick={() => handleSendInvitation(true)} className="primary-btn mt-2">
                    Send Invitation
                  </button>
                </div>
              )}


              {errorMessage && <p className="text-red-600 text-sm mt-1">{errorMessage}</p>}

              <div className="share-content-div mt-4">
                <h6 className="text text-lg mb-2">Team Members</h6>
                {selectedQuoteForTeam?.followers?.length > 0 ? (
                  <div className="overflow-x-auto">
                    <table className="table w-full">
                      <thead>
                        <tr>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Email</th>
                          <th>Role</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedQuoteForTeam.followers.map((item) => (
                          <tr key={item._id}>
                            <td>{item.firstName}</td>
                            <td>{item.lastName || ""}</td>
                            <td>{item.email}</td>
                            <td>
                              {item._id === selectedQuoteForTeam.userId._id ? (
                                "Owner"
                              ) : (
                                <Form.Select
                                  onChange={handleChangeOwnerDropDown}
                                  defaultValue="follower"
                                  className="!w-28"
                                >
                                  <option value={item._id}>Owner</option>
                                  <option value="follower">Follower</option>
                                </Form.Select>
                              )}
                            </td>
                            <td>
                              {item._id !== selectedQuoteForTeam.userId._id && (
                                <div
                                  className="cursor-pointer flex items-center justify-center"
                                  onClick={() => {
                                    setUserSelectedToDelete(item._id);
                                    setShowCaptchaModal(true);
                                  }}
                                >
                                  <DeleteIcon />
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-sm text-gray-500">No user is added as Team Member!</p>
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default TeamCollaboration;
